const IPV4_PATTERN = /^(\d{1,3}\.){3}\d{1,3}$/;

// hostnames with no sub-domain of their own; anything prefixed before one of these is the sub-domain.
// sorted longest-first so e.g. "development.funtowait.com" matches before the shorter "funtowait.com"
const BASE_HOSTNAMES = ["staging.funtowait.com", "development.funtowait.com", "funtowait.com"].sort(
    (a, b) => b.length - a.length
);
/** Max 4 layers is acceptable
 * development.funtowait.com
 * xxx.development.funtowait.com
 * staging.funtowait.com
 * ooo.staging.funtowait.com
 * funtowait.com
 * ppp.funtowait.com
 */
export function domainQuery(hostname: string = window.location.hostname): string | undefined {
    if (IPV4_PATTERN.test(hostname)) return undefined;

    for (const base of BASE_HOSTNAMES) {
        if (hostname === base) return undefined;
        if (hostname.endsWith(`.${base}`)) {
            return hostname.slice(0, -(base.length + 1));
        }
    }

    const labels = hostname.split(".").filter(Boolean);
    const isLocalhost = labels[labels.length - 1] === "localhost";
    const minLabelsForSubdomain = isLocalhost ? 2 : 3;

    return labels.length >= minLabelsForSubdomain ? labels[0] : undefined;
}
